import React from 'react';
import { Link } from 'react-router-dom';
import { Award, ScrollText, FileCode } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Certificates = () => {
  const certificates = [
    {
      id: 1,
      title: 'GST Certificate of Registration',
      description:
        'This certificate is awarded to recognize the registration of the entity under the Goods and Services Tax (GST) regime, as mandated by the Government of India.',
      image: require('../assets/gst_logo.png'),
      pdf: '/pdfs/gst_certificate.pdf', // ✅ starts with /
    },
    {
      id: 2,
      title: 'Import Export Code (IEC) Certificate',
      description:
        'The Import Export Code (IEC) is a unique 10-digit code issued by the Directorate General of Foreign Trade (DGFT), Government of India. It is mandatory for any entity engaged in the import or export of goods and services.',
      image: require('../assets/importexportcode.png'),
      pdf: '/pdfs/certificateOfIEC.pdf',
    },
    {
      id: 3,
      title: 'Udyami Certificate',
      description:
        'The Udyami Certificate is issued by the Ministry of Micro, Small and Medium Enterprises (MSME), Government of India, to promote and support small businesses and entrepreneurs.',
      image: require('../assets/udyami.png'),
      pdf: '/pdfs/udyami_register.pdf',
    },
  ];
  

  return (
    <main className="min-h-screen bg-[#FDF7F3]">

      {/* Hero Section */}
   <div className="relative h-[40vh] bg-[#B08968] flex items-center justify-center text-center px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-xl md:text-2xl mb-4 text-dark">
            Authenticated by industry experts: Our certifications guarantee the authenticity and quality of our spices, dehydrated onions, onion powder.
          </h1>
          <button className="bg-[#5C3D2E] text-white px-6 py-2 rounded hover:bg-[#4A3228] transition-colors">
            OUR CERTIFICATE
          </button>
        </div>
      </div>



      {/* Recognized Certificate Section */}
      <div className="max-w-7xl mx-auto px-4 py-20">
        <h2 className="text-4xl md:text-5xl font-serif text-center mb-8">
          Recognized Certificate
        </h2>
        <p className="text-center text-gray-700 max-w-4xl mx-auto mb-16 text-lg font-inter">
          Explore our range of certifications that validate our commitment to quality, excellence, and compliance in our industry. Each certificate represents our dedication to maintaining high standards and contributing positively to the community.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {certificates.map((cert) => (
            <div key={cert.id} className="bg-white rounded-lg shadow-lg p-6 text-center">
              <div className="h-48 relative mb-6">
                <img
                  src={cert.image}
                  alt={cert.title}
                  className="object-contain w-full h-full"
                  style={{ objectFit: 'contain' }}
                />
              </div>
              <h3 className="text-2xl font-serif mb-4">{cert.title}</h3>
              <p className="text-gray-600 mb-6">{cert.description}</p>
              {/* <Link
                to="#"
                className="inline-flex items-center text-[#5C3D2E] hover:text-[#4A3228] border-2 border-[#5C3D2E] px-6 py-2 rounded transition-colors"
              >
                <ScrollText className="mr-2" />
                View Certificate
              </Link> */}
              <a
                href={cert.pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-[#5C3D2E] hover:text-[#4A3228] border-2 border-[#5C3D2E] px-6 py-2 rounded transition-colors"
              >
                <ScrollText className="mr-2" />
                View Certificate
              </a>

            </div>
          ))}
        </div>
      </div>

    </main>
  );
};

export default Certificates;
